import { render } from "./nutzerverwaltung.vue?vue&type=template&id=82cfe350"
import script from "./nutzerverwaltung.vue?vue&type=script&lang=js"
export * from "./nutzerverwaltung.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__